module.exports = __webpack_public_path__ + "img/logo-footer.bb920d9b.png";